export var authenticationConstants = {
  loginToken: 'Formative.loginToken',
  loginTokenExpires: 'Formative.loginTokenExpires',
  refreshToken: 'Formative.refreshToken',
  refreshTokenExpiration: 'Formative.refreshTokenExpiration',
  sessionId: 'Formative.sessionId',
  userId: 'Formative.userId'
};